export type PlayerStat = {
  number: number;
  name: string;
  position: string;
  points: number;
  rebounds: number;
  assists: number;
  minutes: number;
};

const SURNAMES = ["王", "李", "张", "刘", "陈", "杨", "赵", "黄", "周", "吴", "徐", "孙", "马", "朱", "胡", "郭", "林", "何", "高", "罗"];
const GIVEN = ["伟", "强", "磊", "洋", "勇", "军", "杰", "涛", "明", "超", "浩", "宇", "鹏", "亮", "斌", "峰", "刚", "宁", "岩", "凯"];
const POSITIONS = ["控卫", "分卫", "小前", "大前", "中锋", "替补"];

function hash(seed: string): number {
  let h = 0;
  for (let i = 0; i < seed.length; i += 1) {
    h = (h * 31 + seed.charCodeAt(i)) % 100000;
  }
  return h;
}

export function buildRoster(seed: string, scorer: number): PlayerStat[] {
  const base = hash(seed);
  const star = scorer > 90 ? 30 : scorer > 60 ? 22 : 16;
  return Array.from({ length: 8 }).map((_, i) => {
    const s = base + i * 47;
    const points = Math.max(3, Math.round(star * (i === 0 ? 1 : i === 1 ? 0.82 : 0.68 - i * 0.06)) + (s % 7));
    return {
      number: (s % 30) + 1,
      name: `${SURNAMES[s % SURNAMES.length]}${GIVEN[(s + i) % GIVEN.length]}`,
      position: i < 5 ? POSITIONS[i] : POSITIONS[5],
      points,
      rebounds: (s % 12) + 2,
      assists: (s % 9) + 1,
      minutes: 34 - i * 2,
    };
  });
}

export default buildRoster;